import React from 'react';
import CustomGrid from '../../../../common/components/CustomGrid';
import CustomCard from '../../../../common/components/CustomCard';

import AttendanceCalendarDataController from '../../../../common/components/AllCalendars/AttendaceCalednar/AttendanceCalendarDataController';

const AttendanceCalendarPresenter = () => {
  return (
    <CustomGrid>
      <CustomCard
        cardHeight="365px"
        cardWidth="auto"
        cardSize={{ card_title: '' }}
      >
        <AttendanceCalendarDataController />
      </CustomCard>
    </CustomGrid>
  );
};
export default AttendanceCalendarPresenter;
